import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PayrollStructureListSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/payroll-engine/_layout/payroll-structures/')({
  validateSearch: zodValidator(PayrollStructureListSearchSchema),
  component: () => null
});